import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage, showLayer } from '@/utils/layer'
import React, { Fragment, useRef, useState, useCallback } from 'react'
import { Formik, Form, FieldArray, FormikProps, FormikHelpers } from 'formik'
import { Column, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import Input from '../../../../../../../../components/input/input'
import './edit-goods.scss'
import classNames from 'classnames'
import { GoodsModel, goodsModel } from './modules/model'
import { Radio, Switch } from 'formik-antd'
import { observer } from 'mobx-react'
import { GoodsCategoryFormItem } from './modules/form/goods-category'
import Cascader from '@/components/input/cascader'
import { GoodsStockUnitFormItem } from './modules/form/stock-unit'
import SalePrice from './modules/form/sale-price/sale-price'
import { GoodsSupplierFormItem } from './modules/form/supplier'
import { shopStore } from '@/store/shop'
import { Switch as AntdSwitch, Spin } from 'antd'
import Button from '@/components/button/button'
import { $post } from '@/api'
import { get, INPUT_NUMBER_LIMIT_REGEXP } from '@/utils'
import $msg from '@/utils/message'
import { Goods, IMallDisplay, Unit } from '@/model/types/goods'
import { getQiniuImgUrl } from '@/config/qiniu'
import Iconfont from '@/components/iconfont/iconfont'
import { ChooseMaterialDialog } from '@/views/main/modules/goods-manage/components/material-library/choose-material-dialog'
import { Image } from 'antd'
import { checkValidate } from '@/utils/form'
import { useRequest, useMount } from 'ahooks'
import { goodsLibraryStore } from '../../store/goods-library'

export interface IPricingMethod {
    id?: number
    pricing_method_id: number | null
    sales_unit_id: number
    sales_unit_ratio: string
    sale_prices: {
        id?: number
        threshold: number | string
        sale_price: string | number
        sale_unit: Unit
    }[]
    member_price: {
        // 会员价
        sale_price: string | number
        amount_limit: string
        sale_unit: Unit
    }
    mall_display?: IMallDisplay
    isShowMemberPriceLimit: boolean
    price_annotation: string
    price_code: string
    barcodes: any[]
    scale_num: string
    search_sequence?: string
    sales_unit: Unit
    method_type: 0 | 1 | 2
    newPrice?: boolean
}

export interface IGoodProfile {
    branch_review_needed: boolean
    negative_stock_mode: number
    stock_deduction_mode: number
}

export interface IgoodsForm {
    pricing_methods: IPricingMethod[]
    // sale_prices: IStairPrice[]
    price_annotation: string // 计价说明
    goods_code: string
    barcodes: string[]
    name: string
    img_url: string
    img_info: {
        uid: string
        material_type: string
        name: string
        url: string
        size: string
        duration: string
        proportion: string
    }
    groups: number[] // 用于与表单绑定，不实际提交到服务端
    group_id: number
    secondary_group_id: number | undefined
    participate_discount: 0 | 1 // "1": "参与优惠", "0": "不参与优惠"
    category_id: number
    // purchase_price: number // 进价
    stock: number
    stock_unit_id: number // 商品库存单位
    sales_unit_id: number // 商品销售单位
    negative_stock_mode: 0 | 1 | 2 // "0": "不处理", "1": "预警", "2": "禁止" (不存在1了)
    stock_deduction_mode: 0 | 1 // "0": "添加到订单时", "1": "订单结算时"
    on_mall: boolean | null // 货架
    on_cashier: boolean // 收银台
    supplier_ids: any[]
    producer: string // 产地
    allow_multiple_units: boolean // 是否多个单位 （单位模式） true 多单位 false 单一单位
    sales_unit_ratio: number
    sales_unit?: any
    chain_goods_id?: number
    point_status: number // 商品积分状态  "0": 不参与积分, "1": 正常积分, "2": 额外送积分
    extra_point?: number // 额外赠送积分
    package_include: { name: string }[] // 含有此商品的套餐
}

export interface IGoodsFormErrors {
    name?: string
    barcodes: string[]
    pricing_methods: {
        member_price?: string
        sales_unit_ratio?: string
        barcodes: string[]
        sale_prices: {
            threshold?: string
            sale_price?: string
        }[]
        scale_num?: string
    }[]
}

const getGoodsFormInitState = (): IgoodsForm => ({
    // 多售价
    pricing_methods: [
        {
            isShowMemberPriceLimit: false,
            pricing_method_id: null, // 计价方式id
            sales_unit_id: 2, // 计价单位ID
            method_type: 0,
            sales_unit_ratio: '1', //  计价单位换算率
            sale_prices: [
                {
                    sale_price: '',
                    threshold: 0,
                    sale_unit: {
                        id: 2,
                        name: '斤',
                        status: 0,
                    },
                },
            ],
            member_price: {
                sale_price: '',
                amount_limit: '',
                sale_unit: {
                    id: 2,
                    name: '斤',
                    status: 0,
                },
            },
            mall_display: {
                underline_price: null,
            },
            price_annotation: '', // 计价说明
            price_code: '', // 商品编码
            scale_num: '', // 条码秤序号
            barcodes: [''],
            sales_unit: {
                id: 2,
                name: '斤',
                status: 0,
            },
        },
    ],
    price_annotation: '',
    goods_code: '',
    barcodes: [''],
    name: '',
    img_url: '',
    img_info: {
        uid: '',
        material_type: '',
        name: '',
        url: '',
        size: '',
        duration: '',
        proportion: '',
    },
    groups: [], // 默认分组id
    group_id: 0, // 默认分组id
    secondary_group_id: undefined,
    participate_discount: 1, // 参与优惠
    category_id: 223,
    stock: 0,
    chain_goods_id: void 0,
    stock_unit_id: 2, // 默认库存单位也为斤
    sales_unit_id: 2, // 默认销售单位也为斤
    negative_stock_mode: 2,
    stock_deduction_mode: 0,
    on_mall: shopStore.shopInfo?.wsc_status === 1 ? true : null,
    on_cashier: true,
    supplier_ids: [],
    producer: '', // 产地
    allow_multiple_units: shopStore.shopInfo?.shop_version !== 0 ? true : false, // 默认为多单位模式
    sales_unit_ratio: 1, // 计价单位换算
    point_status: 1,
    extra_point: 0,
    package_include: [],
})

interface EditGoodsProps {
    goodsModel: GoodsModel
    mode: 'create' | 'edit'
    goodsId?: number
}

export const EditGoods: React.FC<EditGoodsProps> = observer(props => {
    const cls = (...args: string[]) => getBEMCls('edit-goods', ...args)
    const formikRef = useRef<FormikProps<IgoodsForm>>(null)
    const [isKeepAdd, setKeepAddStatus] = useState(true)
    const formInitValues: IgoodsForm = getGoodsFormInitState()

    useMount(() => {
        initCreateGoods()
        if (props.mode === 'edit') {
            goodsModel.getScaleCode()
            getGoodsInfo.run()
        }
    })

    const initCreateGoods = useCallback(() => {
        // 初始化商品需要的信息
        goodsModel.init(true, true).then(() => {
            // 初始选择默认分组
            const defaultGroup = goodsModel.goodsGroup.find(val => val.is_default)
            if (props.mode === 'create' && formikRef.current) {
                formikRef.current.setFieldValue('groups', [
                    defaultGroup?.id,
                    get(defaultGroup, 'secondary_group[0].id', void 0),
                ])
                formikRef.current.setFieldValue('goods_code', goodsModel.generateCode?.new_code)
                formikRef.current.setFieldValue(
                    'pricing_methods[0].price_code',
                    goodsModel.generateCode?.new_price_code[0][0],
                )
                formikRef.current.setFieldValue('stock_deduction_mode', goodsModel.goodProfile?.stock_deduction_mode)
                formikRef.current.setFieldValue('negative_stock_mode', goodsModel.goodProfile?.negative_stock_mode)
                formikRef.current.setFieldValue(
                    'pricing_methods[0].scale_num',
                    shopStore.shopInfo?.is_auto_scale_num ? goodsModel.autoScaleNum : '',
                )
            }
        })
    }, [props.mode])

    const { data: chainGoodProfile } = useRequest<{
        profile: IGoodProfile
    }>(() =>
        shopStore.isChainShop
            ? $post({
                  url: '/goods/getshopgoodsprofile',
              })
            : new Promise(() => {}),
    )

    const getGoodsInfo = useRequest(
        () =>
            $post({
                url: 'goods/getsinglegoods',
                params: {
                    goods_id: props.goodsId,
                },
            }),
        {
            manual: true,
            onSuccess: (goods: Goods) => {
                if (formikRef.current) {
                    // 把后台获取到的参数转换为表单参数
                    const values = Object.assign({}, formInitValues, goods, {
                        groups: [goods.group.id, goods.secondary_group.id],
                        stock_unit_id: goods.stock_unit.id,
                        on_cashier: goods.status === 0,
                        category_id: goods.category.id,
                        supplier_ids: goods.suppliers.map(val => val.id),
                        negative_stock_mode: goods.negative_stock_mode === 0,
                        point_status: goods.goodspointconfig.status,
                        extra_point: goods.goodspointconfig.extra_point,
                        pricing_methods: goods.pricing_methods.map(pricingMethod => {
                            return {
                                isShowMemberPriceLimit: false,
                                pricing_method_id: pricingMethod.pricing_method_id, // 计价方式id
                                sales_unit_id: pricingMethod.sales_unit.id, // 计价单位ID
                                sales_unit_ratio: pricingMethod.sales_unit_ratio, //  计价单位换算率
                                sale_prices: pricingMethod.sale_prices.map(salePrice => {
                                    return {
                                        sale_price: salePrice.sale_price || '',
                                        threshold: salePrice.threshold || '',
                                    }
                                }),
                                method_type: pricingMethod.method_type,
                                member_price: {
                                    sale_price: pricingMethod.member_price?.sale_price || '',
                                    amount_limit: pricingMethod.member_price?.amount_limit || '',
                                },
                                mall_display: pricingMethod.mall_display || {
                                    underline_price: null,
                                },
                                price_annotation: pricingMethod.price_annotation, // 计价说明
                                price_code: pricingMethod.price_code, // 商品编码
                                scale_num: pricingMethod.scale_num, // 条码秤序号
                                barcodes: pricingMethod.barcodes,
                            }
                        }),
                    })
                    formikRef.current.setValues(values)
                }
            },
            onError: e => $msg('error', e.message),
        },
    )

    const editGoodReq = useRequest(
        params =>
            $post({
                url: '/goods/editgoods',
                params: params,
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '更新成功')
                layerManage.pop()
                goodsLibraryStore.setUpdateGroupStatus(!goodsLibraryStore.updateGroupStatus)
            },
            onError: e => {
                $msg('error', e.message)
            },
        },
    )

    const addGoodReq = useRequest(
        (params: any, formikHelpers: FormikHelpers<IgoodsForm>) =>
            $post({
                url: shopStore.isChainShop ? '/goods/branchcreategoods' : '/goods/addgoods',
                params: params,
            })
                .then(() => {
                    $msg(
                        'success',
                        chainGoodProfile?.profile.branch_review_needed ? '创建成功，等待总部审核' : '创建成功',
                    )

                    if (isKeepAdd) {
                        formikHelpers.resetForm()
                        initCreateGoods()
                    } else {
                        layerManage.pop()
                    }
                    goodsLibraryStore.setUpdateGroupStatus(!goodsLibraryStore.updateGroupStatus)
                })
                .catch(e => {
                    $msg('error', e.message)
                }),
        {
            manual: true,
        },
    )

    function onSubmit(values: IgoodsForm, formikHelpers: FormikHelpers<IgoodsForm>) {
        const params = {
            name: values.name,
            img_url: values.img_url,
            pricing_methods: values.pricing_methods.map(pricingMethod => {
                return {
                    id: pricingMethod.id,
                    sales_unit_id: pricingMethod.sales_unit_id,
                    sales_unit_ratio: pricingMethod.sales_unit_ratio,
                    sale_prices: pricingMethod.sale_prices.map(salePrice => {
                        return {
                            sale_price_id: salePrice.id,
                            sale_price: salePrice.sale_price,
                            threshold: salePrice.threshold || 0,
                            sale_unit: pricingMethod.sales_unit_id,
                        }
                    }),
                    method_type: pricingMethod.method_type,
                    ...(values.on_mall
                        ? {
                              mall_display: {
                                  underline_price:
                                      pricingMethod.method_type === 1 ||
                                      pricingMethod.mall_display?.underline_price === undefined ||
                                      pricingMethod.mall_display?.underline_price === null ||
                                      (typeof pricingMethod.mall_display?.underline_price === 'string' &&
                                          pricingMethod.mall_display.underline_price.trim() === '')
                                          ? null
                                          : pricingMethod.mall_display.underline_price,
                              },
                          }
                        : {}),
                    member_price: pricingMethod.member_price.sale_price
                        ? {
                              sale_price: pricingMethod.member_price.sale_price,
                              amount_limit: pricingMethod.member_price.amount_limit || undefined,
                              sale_unit: pricingMethod.sales_unit_id,
                          }
                        : undefined,
                    price_annotation: pricingMethod.price_annotation,
                    price_code: pricingMethod.price_code,
                    scale_num: pricingMethod.scale_num ? pricingMethod.scale_num : undefined, // 条码秤序号
                    barcodes: pricingMethod.barcodes.filter(val => val.length > 0),
                }
            }),
            goods_code: values.goods_code,
            barcodes: values.barcodes.filter(item => item.length > 0),
            group_id: values.groups[0],
            secondary_group_id: values.groups[1],
            category_id: values.category_id,
            supplier_ids: values.supplier_ids,
            stock: values.stock,
            stock_unit_id: values.stock_unit_id,
            negative_stock_mode: values.negative_stock_mode ? 0 : 2,
            participate_discount: values.participate_discount ? 1 : 0,
            allow_multiple_units: values.allow_multiple_units,
            producer: undefined, // 产地
            chain_goods_id: values.chain_goods_id, // 连锁商品 id
            on_mall: values.on_mall,
            on_cashier: values.on_cashier,
            point_status: values.point_status, // 商品积分状态
            extra_point: values.extra_point, // 额外赠送积分
            stock_deduction_mode: values.stock_deduction_mode,
        }
        props.mode === 'edit'
            ? editGoodReq.run({
                  goods_id: props.goodsId,
                  ...params,
              })
            : addGoodReq.run(params, formikHelpers)
    }

    return (
        <BaseDrawer isShow title={`${props.mode === 'edit' ? '编辑' : '新建'}商品`} onClose={() => layerManage.pop()}>
            <Formik
                validateOnBlur={true}
                innerRef={formikRef}
                initialValues={formInitValues}
                onSubmit={onSubmit}
                validate={validateForm}
            >
                {({ values, handleChange, handleBlur, errors, touched, setFieldValue, submitForm }) => {
                    const stockUnitName = props.goodsModel.goodsUnit.find(val => val.id === values.stock_unit_id)?.name
                    const checkError = (key: string) => {
                        return !!(get(errors, key) && get(touched, key))
                    }

                    const getErrorStr = (key: string) => {
                        return get(errors, key) && get(touched, key) && get(errors, key)
                    }

                    return (
                        <Form data-height-100p>
                            <Column data-height-100p data-overflow-hidden>
                                <div data-expaned data-overflow-auto className={cls()}>
                                    <Spin spinning={getGoodsInfo.loading}>
                                        {chainGoodProfile?.profile.branch_review_needed && (
                                            <div className={cls('top-tip')}>
                                                *分店新建商品需连锁总部审核，审核通过后会添加到商品库
                                            </div>
                                        )}
                                        <Row data-align-items-center className={cls('title-wrap')}>
                                            <i className={cls('title-wrap', 'line')}></i>
                                            <span className={cls('title-wrap', 'title')}>基本信息</span>
                                        </Row>

                                        {/* 商品名称 */}
                                        <Column>
                                            <Row
                                                data-position-relative
                                                data-align-items-center
                                                data-padding-h-24
                                                data-margin-top-8
                                            >
                                                <span
                                                    className={classNames(
                                                        cls('form-item', 'title'),
                                                        cls('form-item', 'require'),
                                                    )}
                                                >
                                                    商品名称
                                                </span>
                                                <Input
                                                    error={!!(errors.name && touched.name)}
                                                    name="name"
                                                    type="text"
                                                    maxLength={30}
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="输入商品名称"
                                                    inputsuffix={() => (
                                                        <span data-font-size-14 data-color-666>
                                                            {values.name.length}/30
                                                        </span>
                                                    )}
                                                ></Input>
                                            </Row>
                                            <span
                                                data-padding-left-96
                                                data-padding-top-8
                                                className={classNames(cls('form-item', 'error'))}
                                            >
                                                {errors.name && touched.name && errors.name}
                                            </span>
                                        </Column>

                                        {/* 分类 */}
                                        <GoodsCategoryFormItem goodsModel={props.goodsModel}></GoodsCategoryFormItem>

                                        <Row data-align-items-center data-padding-h-24>
                                            <span className={classNames(cls('form-item', 'title'))}>商品分组</span>
                                            <Cascader
                                                placeholder="请选择"
                                                name="groups"
                                                allowClear={false}
                                                options={props.goodsModel.goodsGroup}
                                                fieldNames={{
                                                    label: 'name',
                                                    value: 'id',
                                                    children: 'secondary_group',
                                                }}
                                                onChange={() => {}}
                                                inputsuffix={() => (
                                                    <i data-color-999 className="iconfont icon6xiala2-202"></i>
                                                )}
                                            ></Cascader>
                                        </Row>

                                        <Row
                                            data-align-items-center
                                            data-padding-h-24
                                            data-margin-top-16
                                            data-height-50
                                        >
                                            <span className={classNames(cls('form-item', 'title'))}>单位模式</span>
                                            <Radio.Group
                                                name="allow_multiple_units"
                                                value={values.allow_multiple_units}
                                                onChange={event => {
                                                    if (event.target.value === false) {
                                                        // 选择单一单位，需要把计价方式中的单位设置成同一个单位
                                                        values.pricing_methods.forEach((val, index) => {
                                                            setFieldValue(
                                                                `pricing_methods[${index}].sales_unit_id`,
                                                                values.stock_unit_id,
                                                            )
                                                        })
                                                    }
                                                }}
                                            >
                                                <Radio name="allow_multiple_units" value={false}>
                                                    单一单位
                                                </Radio>
                                                <Radio name="allow_multiple_units" value={true}>
                                                    多单位
                                                </Radio>
                                            </Radio.Group>
                                        </Row>

                                        <Row data-align-items-center data-padding-h-24 data-margin-top-31>
                                            <span
                                                data-color-000
                                                data-font-weight-600
                                                className={classNames(cls('form-item', 'title'))}
                                            >
                                                库存设置
                                            </span>
                                            <Row data-align-items-center data-height-50>
                                                <span
                                                    data-margin-right-8
                                                    data-font-size-14
                                                    data-color-000
                                                    data-font-weight-600
                                                >
                                                    允许负库存销售
                                                </span>
                                                <Switch name="negative_stock_mode"></Switch>
                                            </Row>
                                        </Row>

                                        {/* 库存单位 */}
                                        <GoodsStockUnitFormItem goodsModel={props.goodsModel}></GoodsStockUnitFormItem>

                                        <Row data-align-items-center data-padding-h-24>
                                            <span
                                                data-color-999
                                                data-font-weight-400
                                                className={classNames(cls('form-item', 'title'))}
                                            ></span>
                                            <Row data-align-items-center data-height-50 data-expaned>
                                                <Input
                                                    reg={INPUT_NUMBER_LIMIT_REGEXP}
                                                    name="stock"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.stock}
                                                    inputprefix={() => (
                                                        <span
                                                            data-color-000
                                                            data-font-weight-600
                                                            className={classNames(cls('form-item', 'title'))}
                                                        >
                                                            初始库存
                                                        </span>
                                                    )}
                                                    inputsuffix={() => (
                                                        <span data-font-size-14 data-color-666>
                                                            {stockUnitName}
                                                        </span>
                                                    )}
                                                ></Input>
                                            </Row>
                                        </Row>

                                        {/* 售价 */}
                                        <SalePrice showPriceType={!!values.on_mall} mode={props.mode}></SalePrice>

                                        <Row data-align-items-center data-margin-top-24 className={cls('title-wrap')}>
                                            <i className={cls('title-wrap', 'line')}></i>
                                            <span className={cls('title-wrap', 'title')}>其他信息</span>
                                        </Row>

                                        {/* 供货商 */}
                                        <GoodsSupplierFormItem goodsModel={props.goodsModel}></GoodsSupplierFormItem>

                                        <Row data-align-items-center data-padding-h-24>
                                            <span className={classNames(cls('form-item', 'title'))}>商品编码</span>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <Input
                                                    reg={/^\d{0,18}$/}
                                                    name="goods_code"
                                                    value={values.goods_code}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="请输入"
                                                    inputsuffix={() => {
                                                        return (
                                                            <Row data-algin-items-center>
                                                                <span data-font-size-14 data-color-000>
                                                                    {values.goods_code.length}/18
                                                                </span>
                                                            </Row>
                                                        )
                                                    }}
                                                ></Input>
                                            </Row>
                                        </Row>

                                        <FieldArray name="barcodes">
                                            {barcodesArrayHelper => (
                                                <Fragment>
                                                    {values.barcodes?.map((val, index, arr) => {
                                                        return (
                                                            <Column key={index}>
                                                                <Row data-align-items-center data-padding-h-24>
                                                                    <span
                                                                        style={{
                                                                            width: arr.length > 1 ? '74px' : '56px',
                                                                        }}
                                                                        className={classNames(
                                                                            cls('form-item', 'title'),
                                                                        )}
                                                                    >
                                                                        商品条码{arr.length > 1 && index + 1}
                                                                    </span>
                                                                    <Row
                                                                        data-align-items-center
                                                                        data-expaned
                                                                        data-position-relative
                                                                    >
                                                                        <Input
                                                                            reg={/^\d{0,14}$/}
                                                                            error={checkError(`barcodes[${index}]`)}
                                                                            name={`barcodes[${index}]`}
                                                                            value={values.barcodes[index]}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            placeholder="请输入"
                                                                            onKeyDown={e => {
                                                                                e.stopPropagation()
                                                                            }}
                                                                            inputsuffix={() => {
                                                                                return (
                                                                                    <Row data-algin-items-center>
                                                                                        <span
                                                                                            data-font-size-14
                                                                                            data-color-000
                                                                                        >
                                                                                            {
                                                                                                values.barcodes[index]
                                                                                                    .length
                                                                                            }
                                                                                            /14
                                                                                        </span>
                                                                                        {index !== 0 && (
                                                                                            <i
                                                                                                onClick={() => {
                                                                                                    barcodesArrayHelper.remove(
                                                                                                        index,
                                                                                                    )
                                                                                                }}
                                                                                                style={{
                                                                                                    color: '#f00',
                                                                                                }}
                                                                                                data-margin-left-4
                                                                                                className="iconfont icon6yichu-20"
                                                                                            ></i>
                                                                                        )}
                                                                                    </Row>
                                                                                )
                                                                            }}
                                                                        ></Input>
                                                                    </Row>
                                                                </Row>
                                                                <span
                                                                    style={{
                                                                        marginLeft: arr.length > 1 ? '114px' : '96px',
                                                                    }}
                                                                    data-padding-top-8
                                                                    className={classNames(cls('form-item', 'error'))}
                                                                >
                                                                    {getErrorStr(`barcodes[${index}]`)}
                                                                </span>
                                                            </Column>
                                                        )
                                                    })}

                                                    <Row data-align-items-center data-height-50 data-padding-h-24>
                                                        <span
                                                            data-color-999
                                                            data-font-weight-400
                                                            className={classNames(cls('form-item', 'title'))}
                                                        ></span>
                                                        <Row
                                                            onClick={() => {
                                                                barcodesArrayHelper.push('')
                                                            }}
                                                            data-align-items-center
                                                            data-expaned
                                                            data-position-relative
                                                        >
                                                            <span className="text-btn-blue">+新增条码</span>
                                                        </Row>
                                                    </Row>
                                                </Fragment>
                                            )}
                                        </FieldArray>

                                        <Row data-align-items-center data-padding-h-24>
                                            <span className={classNames(cls('form-item', 'title'))}>商品图片</span>
                                            <Row
                                                data-align-items-center
                                                data-expaned
                                                data-position-relative
                                                onClick={() => {
                                                    showLayer(
                                                        <ChooseMaterialDialog
                                                            onSelected={data => {
                                                                layerManage.pop()
                                                                setFieldValue('img_url', data.url)
                                                            }}
                                                        ></ChooseMaterialDialog>,
                                                    )
                                                }}
                                            >
                                                {values.img_url ? (
                                                    <div className={cls('img')}>
                                                        <Image
                                                            src={getQiniuImgUrl(values.img_url)}
                                                            width={60}
                                                            height={60}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                            }}
                                                        />
                                                        <div
                                                            className={cls('img', 'delete')}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                setFieldValue('img_url', '')
                                                            }}
                                                        >
                                                            <Iconfont name="icon3shanchu-20" size={20}></Iconfont>
                                                        </div>
                                                        <div
                                                            className={cls('img', 'change')}
                                                            onClick={e => {
                                                                e.stopPropagation()
                                                                showLayer(
                                                                    <ChooseMaterialDialog
                                                                        onSelected={data => {
                                                                            layerManage.pop()
                                                                            setFieldValue('img_url', data.url)
                                                                        }}
                                                                    ></ChooseMaterialDialog>,
                                                                )
                                                            }}
                                                        >
                                                            更换
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <Column
                                                        className={classNames(cls('img'), cls('img', 'border'))}
                                                        data-center
                                                    >
                                                        <Iconfont name="icon6shangchuan-24" size={24}></Iconfont>
                                                        <div data-font-size-12 data-color-999>
                                                            素材库
                                                        </div>
                                                    </Column>
                                                )}
                                            </Row>
                                        </Row>

                                        <Row data-align-items-center data-margin-top-24 className={cls('title-wrap')}>
                                            <i className={cls('title-wrap', 'line')}></i>
                                            <span className={cls('title-wrap', 'title')}>高级设置</span>
                                        </Row>

                                        <Row
                                            data-align-items-center
                                            data-padding-h-24
                                            data-margin-top-16
                                            data-height-50
                                        >
                                            <span className={classNames(cls('form-item', 'title'))}>积分</span>
                                            <Radio.Group name="point_status" value={values.point_status}>
                                                <Radio name="point_status" value={0}>
                                                    不参与积分赠送
                                                </Radio>
                                                <Radio name="point_status" value={1}>
                                                    正常积分
                                                </Radio>
                                                <Radio name="point_status" value={2}>
                                                    额外积分
                                                </Radio>
                                            </Radio.Group>
                                        </Row>

                                        {values.point_status === 2 && (
                                            <Row data-align-items-center data-padding-h-24>
                                                <span className={classNames(cls('form-item', 'title'))}>额外积分</span>
                                                <Row data-align-items-center data-expaned data-position-relative>
                                                    <Input
                                                        reg={INPUT_NUMBER_LIMIT_REGEXP}
                                                        name="extra_point"
                                                        value={values.extra_point}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="请输入"
                                                        onKeyDown={e => {
                                                            e.stopPropagation()
                                                        }}
                                                    />
                                                </Row>
                                            </Row>
                                        )}

                                        <Row data-align-items-center data-padding-h-24 data-height-50>
                                            <span data-width-84 className={classNames(cls('form-item', 'title'))}>
                                                参与店铺优惠
                                            </span>
                                            <Row
                                                data-align-items-center
                                                data-justify-content-space-between
                                                data-expaned
                                                data-position-relative
                                            >
                                                <span data-font-size-12 data-color-999>
                                                    包括会员日折扣、手动整单折扣
                                                </span>
                                                <Switch name="participate_discount"></Switch>
                                            </Row>
                                        </Row>

                                        <Row data-align-items-center data-padding-h-24 data-height-50>
                                            <span data-width-112 className={classNames(cls('form-item', 'title'))}>
                                                默认库存扣减方式
                                            </span>
                                            <Row
                                                data-align-items-center
                                                data-justify-content-flex-end
                                                data-expaned
                                                data-position-relative
                                            >
                                                <Radio.Group name="stock_deduction_mode">
                                                    <Radio name="stock_deduction_mode" value={0}>
                                                        付款减库存
                                                    </Radio>
                                                    <Radio name="stock_deduction_mode" value={1}>
                                                        拍下减库存
                                                    </Radio>
                                                </Radio.Group>
                                            </Row>
                                        </Row>
                                    </Spin>
                                </div>

                                <Row data-justify-content-space-between className={cls('footer')}>
                                    <Row>
                                        {props.mode === 'create' && (
                                            <>
                                                <AntdSwitch
                                                    checked={isKeepAdd}
                                                    onChange={val => {
                                                        setKeepAddStatus(val)
                                                    }}
                                                ></AntdSwitch>
                                                <span data-padding-left-10 data-font-size-14 data-font-weight-600>
                                                    连续添加
                                                </span>
                                                <div className={cls('line')}></div>
                                            </>
                                        )}
                                        <Row>
                                            <span data-color-999 data-font-size-14 data-margin-right-8>
                                                上架到
                                            </span>
                                            <Row
                                                data-cursor-pointer
                                                data-align-items-center
                                                onClick={() => {
                                                    setFieldValue('on_mall', !values.on_mall)
                                                }}
                                            >
                                                <Iconfont
                                                    name={
                                                        values.on_mall
                                                            ? 'icon3duoxuanquanxuan-20'
                                                            : 'icon3duoxuanguan-20'
                                                    }
                                                    size={20}
                                                ></Iconfont>
                                                <span data-margin-left-8>商城货架</span>
                                            </Row>
                                            <Row
                                                data-cursor-pointer
                                                data-align-items-center
                                                data-margin-left-10
                                                onClick={() => {
                                                    setFieldValue('on_cashier', !values.on_cashier)
                                                }}
                                            >
                                                <Iconfont
                                                    name={
                                                        values.on_cashier
                                                            ? 'icon3duoxuanquanxuan-20'
                                                            : 'icon3duoxuanguan-20'
                                                    }
                                                    size={20}
                                                ></Iconfont>
                                                <span data-margin-left-8>收银台</span>
                                            </Row>
                                        </Row>
                                    </Row>
                                    <Button
                                        loading={addGoodReq.loading || editGoodReq.loading || void 0}
                                        types="default"
                                        type="button"
                                        onClick={submitForm}
                                    >
                                        确认{props.mode === 'edit' ? '更新' : '添加'}
                                    </Button>
                                </Row>
                            </Column>
                        </Form>
                    )
                }}
            </Formik>
        </BaseDrawer>
    )
})

function validateForm(values: IgoodsForm) {
    const errors: IGoodsFormErrors = {
        pricing_methods: [],
        barcodes: [],
    }

    if (values.name.trim().length === 0) {
        errors.name = '请输入商品名'
    }

    values.pricing_methods.forEach((pricingMethod, priceingMethodIndex) => {
        errors.pricing_methods.push({
            sale_prices: [],
            barcodes: [],
        })

        if (pricingMethod.sales_unit_ratio.toString().trim().length === 0) {
            errors.pricing_methods![priceingMethodIndex].sales_unit_ratio = '请输入换算规则'
        }

        pricingMethod.sale_prices.forEach((value, salePriceIndex, arr) => {
            errors.pricing_methods[priceingMethodIndex].sale_prices.push({})
            if (arr[salePriceIndex - 1]) {
                if (+value.threshold < +arr[salePriceIndex - 1].threshold) {
                    errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].threshold = '应大于上一级'
                }

                if (+value.sale_price > +arr[salePriceIndex - 1].sale_price) {
                    errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].sale_price = '应小于上一级'
                }
            }

            if (value.sale_price.toString().trim().length === 0) {
                errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].sale_price = '请输入价格'
            }

            if (value.threshold.toString().trim().length === 0 && salePriceIndex) {
                errors.pricing_methods[priceingMethodIndex].sale_prices[salePriceIndex].threshold = '请输入购买量'
            }
        })

        if (pricingMethod.scale_num && pricingMethod.scale_num.length > 0 && pricingMethod.scale_num.length < 4) {
            errors.pricing_methods[priceingMethodIndex].scale_num = '条码秤序号必须为4位'
        }

        if (+pricingMethod.member_price.sale_price > +pricingMethod.sale_prices[0].sale_price) {
            errors.pricing_methods[priceingMethodIndex].member_price = '会员价需小于零售价'
        }

        pricingMethod.barcodes.forEach(val => {
            const str = val.length > 0 && val.length < 8 ? '条码需大于8位' : ''
            errors.pricing_methods[priceingMethodIndex].barcodes.push(str)
        })
    })

    values.barcodes.forEach(val => {
        const str = val.length > 0 && val.length < 8 ? '条码需大于8位' : ''
        errors.barcodes.push(str)
    })

    if (checkValidate(errors)) {
        return {}
    }

    return errors
}
